import { Injectable } from '@angular/core';

import { DataService } from '../data.service';
import { SimpleRepository } from './_simple.repository';
import { IGetallDTO } from 'src/app/model/dto/getall.dto';
import { Collection } from 'src/app/model/orm/collection.model';

@Injectable()
export class CollectionsRepository extends SimpleRepository<Collection> {
    constructor(protected dataService: DataService) {
        super();
        this.sortBy = "pos";
    }
    
    public load(): Promise<void> {
        return new Promise((resolve, reject) => {
            if (new Date().getTime() - this.loadedAt < this.ttl) {
                resolve();
            } else {
                const dto: IGetallDTO = {sortBy: this.sortBy, sortDir: this.sortDir};
                this.dataService.collectionsAll(dto).subscribe(res => {                                                                                      
                    if (res.statusCode === 200) {
                        this.build(res.data);
                        this.loadedAt = new Date().getTime();
                        resolve();
                    } else {                        
                        reject(res.statusCode+": "+res.error);
                    }
                }, err => {
                    reject(err.message);
                });
            }            
        });
    }    

    public build(collections: Array<Collection> = []): void {
        this.xl = collections.length ? collections.map(d => new Collection().build(d)) : [];
    }
}
